import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { TARIFF_IMPORT_JOB_STATUS_TYPE } from '@/features/tariff-import-jobs/models'

/**
 * タリフのインポート履歴の検索条件
 */
export const tariffImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TARIFF_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type TariffImportJobsSearch = InferOutput<
  typeof tariffImportJobsSearchSchema
>
